<template>

    <div>


          <b-row>

            <b-modal
            ref="modalProfile"
            centered
            hide-footer

            hideHeaderClose
                hideHeader
            size="sm"
          >
            <div class="d-block text-center">

              <b-row>

                <b-col
                          sm="12"
                          md="12"
                          lg="12"
                          align="center"
                          style="position: absolute; top: -50px;"
                        >

                        <img v-if="isProfileVerificated" title="Usuario verificado" alt="Usuario verificado" class="badgeVerificacion3" src="/img/verificadoFinal.svg" />
                    <img v-else alt="Usuario no verificado" title="Usuario no verificado" class="badgeVerificacion3" src="/img/no_verificadoFinal.svg" />


                        <b-avatar
                        size="100"
                        :src="photoUser"
                        variant="light-primary"

                        
                    >


                    </b-avatar>

                    </b-col>

                    <b-col
                          sm="12"
                          md="12"
                          lg="12"
                          align="center"
                        >

                        <p style="text-align: center; font-weight: bold;margin-top:50px; margin-bottom: 2px; ">{{displayName}}</p>
                    <p style="text-align: center; font-size: 12px;">{{contacto}}</p>

                    <hr>

                  </b-col>
                 
                

                        <b-col
                         cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                          xl="12"
                          align="center"
                        >

                        <b-button style="border-radius:50px"  variant="primary" size="md" @click="logout">

                                                  
                                      <feather-icon
                                                icon="LogOutIcon"
                                                size="15"
                                                style="margin-right: 5px;"
                                                />

                                            Cerrar sesión

                            </b-button>



                        </b-col>



                </b-row>

                </div>

                </b-modal>
          
            <b-col id="menu_fixed"  class="fixed_header_link "  sm="12" md="12" lg="12" xl="12">

                  <b-row>


                    <b-col cols="2" sm="2" md="2" xl="2" lg="2" style="text-align:left">
                      <img src="/img/eqcoop.svg" width="100px"/>
                    

                  </b-col>

                  <b-col cols="8" sm="8" md="8" xl="8" lg="8"  ></b-col>

                  <b-col  cols="2" sm="2" md="2" xl="2" lg="2" style="text-align: right;"  @click="openModalProfile">

                    <b-avatar
                        size="40"
                        :src="photoUser"
                        variant="light-primary"
                        style="cursor:pointer"
                       
                      

                        
                    >


                    </b-avatar>


                  </b-col>





                  </b-row>

                  </b-col>

        </b-row>

        <b-row style="height: calc(var(--vh, 1vh) * 70);     margin-top: 55px;">

          <b-col cols="12" sm="12" md="12" lg="2" xl="2" align="center"></b-col>

          <b-col cols="12" sm="12" md="6" lg="4" xl="4" align="center">

            <b-card >

              <b-row>

                <b-col cols="12" sm="12" md="12" lg="12" xl="12">

                  <h1 class="invitacion_txt" style="font-size:18px; margin-bottom:15px">¡Hola! <span style="color:#00838C; font-weight: bold;text-transform: capitalize">{{displayName}}</span>, completa tu perfil registrando una contraseña a tu cuenta.</h1>

                            <b-avatar
                            size="100"
                            variant="light-primary"
                            style="margin:auto;">

                            <span class="d-flex align-items-center">

                   
                            <img src="/img/password.svg" style="width: 65px;" />

                            </span>

                            </b-avatar> 

                            <p style="margin-top:10px;margin-bottom:0px; text-align: justify;">Esta contraseña, junto con tu número de celular, te servirá para iniciar sesión en caso de fallar los envios de códigos de verificación hacia tu número celular. </p>
                            <p style="margin-top:10px;margin-bottom:0px; text-align: justify;">El registro de esta contraseña es obligatoria para usuarios que inicien sesión con SMS.  </p>
                    
                              
       


                          


                </b-col>

              </b-row>
     
                 
            </b-card>

            <b-card>
                <b-row> 
            
                  <b-col  cols="4" sm="4" md="4" xl="4" lg="4" style="display:flex" >

                      <b-avatar
                                              size="60"
                                              variant="light-primary"
                                              style="margin:auto;"
                                              >

                                              <span class="d-flex align-items-center">

                                                <svg class="icons_colors3" style="width: 40px;" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 60 60"><g><path d="M30 10.5c-16.822.0-30 6.589-30 15v9c0 8.411 13.178 15 30 15s30-6.589 30-15v-9c0-8.411-13.178-15-30-15zm0 2c15.178.0 28 5.953 28 13s-12.822 13-28 13-28-5.953-28-13 12.822-13 28-13zm4.697 27.824c.063-.005.124-.011.186-.016.632-.05 1.255-.111 1.872-.179.081-.009.165-.014.245-.023v6.964c-.982.122-1.983.219-3 .29v-6.99C34.232 40.354 34.466 40.342 34.697 40.324zM39 39.839c.05-.008.098-.016.148-.024.094-.015.186-.031.28-.047.57-.091 1.132-.192 1.685-.299.13-.025.26-.049.389-.075.167-.034.333-.068.498-.103v6.907c-.971.221-1.974.413-3 .58V39.839zm5-1.02c.392-.101.777-.207 1.158-.316.104-.03.209-.058.312-.089.178-.053.354-.107.53-.162v6.835c-.648.214-1.315.416-2 .605V38.819zm4-1.241c.287-.106.566-.217.844-.328.072-.029.146-.056.217-.085.319-.13.631-.264.939-.4v6.727c-.637.305-1.304.596-2 .871V37.578zM52 35.791c.036-.02.074-.038.111-.058.04-.022.082-.042.122-.064.44-.241.859-.491 1.267-.746.091-.057.179-.114.268-.171.077-.05.157-.098.232-.149v6.484c-.607.467-1.277.914-2 1.342V35.791zM6 34.603c.076.05.155.099.232.149.089.057.178.115.268.171.407.255.827.505 1.267.746.04.022.082.042.122.064.036.02.074.039.111.058v6.637C7.277 42 6.607 41.553 6 41.086V34.603zm4 2.162c.308.136.619.27.939.4.071.029.145.056.217.085.279.111.558.222.844.328v6.786c-.696-.276-1.363-.567-2-.871V36.765zm4 1.488c.176.054.351.109.53.162.103.03.208.059.312.089.381.109.766.215 1.158.316v6.874c-.685-.189-1.352-.391-2-.605V38.253zm4 1.038c.165.035.331.069.498.103.129.026.26.05.389.075.554.107 1.115.208 1.685.299.094.015.186.032.28.047.049.008.098.016.148.024v6.94c-1.026-.168-2.029-.36-3-.58V39.291zm5 .814c.081.009.164.014.245.023.617.068 1.24.129 1.872.179.062.005.123.011.186.016.23.017.465.03.697.045v6.99c-1.017-.071-2.018-.167-3-.29V40.105zM2 34.5v-3.511c.031.041.07.079.102.12.23.293.473.582.737.865.019.02.035.041.054.061.283.3.591.592.912.879C3.87 32.971 3.934 33.029 4 33.086v6.14C2.717 37.753 2 36.158 2 34.5zM28 47.461v-6.996c.661.021 1.326.035 2 .035s1.339-.014 2-.035v6.996c-.662.023-1.328.039-2 .039S28.662 47.484 28 47.461zM58 30.989V34.5c0 1.658-.717 3.253-2 4.727v-6.14c.066-.057.13-.115.195-.173.321-.288.629-.58.912-.879.019-.02.035-.041.054-.061.265-.283.508-.572.738-.865C57.93 31.068 57.969 31.029 58 30.989z"/><path d="M15.97 34.608l-.265.096 3.45.723c.483.101.981.179 1.473.266.097.017.193.036.29.052.558.095 1.121.181 1.69.258.39.053.785.103 1.184.148.359.04.717.08 1.08.112.673.063 1.357.113 2.05.151.128.007.255.016.383.022C28.189 36.478 29.087 36.5 30 36.5c.89.0 1.765-.022 2.626-.062.135-.006.268-.015.402-.022.667-.036 1.325-.084 1.973-.143.397-.035.79-.077 1.183-.121.353-.04.702-.083 1.048-.129.625-.082 1.242-.176 1.854-.28.063-.011.125-.022.188-.033.48-.084.966-.158 1.437-.255l3.398-.701-.253-.095C51.271 32.532 56 28.886 56 25.5c0-5.192-11.119-11-26-11s-26 5.808-26 11c0 3.359 4.657 6.973 11.97 9.108zm9.96-5.109c-2.056-.67-3.228-1.829-3.484-3.443l-.108-.679-.673-.143c-.443-.094-.595-.248-.617-.255l.231-.75c.027-.087.3-.385.942-.568l.449-.128.19-.426c.251-.564.599-1.072 1.033-1.51.186-.188.338-.327.462-.439.427-.39.695-.697.773-1.188.005.002.011.004.017.006 1.464.535 3.154.59 4.318.542.175-.007.354-.011.537-.011 4.036.0 6.304.831 7.138 2.614l.194.414.439.125c.647.183.922.481.95.57l.238.704c-.021.04-.187.208-.625.3l-.673.143-.108.679c-.256 1.614-1.428 2.772-3.484 3.443l-.777.253.24 2.082c.082.71.611 1.331 1.38 1.617l1.689.632c-.196.025-.391.05-.59.073-.658.073-1.325.134-1.998.183-.311.023-.617.051-.934.069-2.052.113-4.143.112-6.194-.003-.326-.018-.64-.047-.959-.071-.671-.049-1.336-.111-1.992-.185-.202-.023-.399-.049-.598-.074l1.726-.623c.785-.284 1.324-.907 1.407-1.626l.239-2.073L25.93 29.499zM30 16.5c14.888.0 24 5.827 24 9 0 2.332-4.936 6.09-13.455 7.922l-4.933-1.844c-.048-.018-.082-.038-.103-.053l-.047-.409c2.524-1.045 3.547-2.699 3.932-4.12.574-.232 1.02-.592 1.287-1.046.279-.475.343-1.028.18-1.558l-.23-.749c-.23-.751-.923-1.392-1.888-1.765-1.719-3.012-5.784-3.371-8.745-3.371-.211.0-.417.005-.62.013-1.388.053-2.647-.094-3.549-.423-.502-.183-.722-.317-.808-.38-.432-.318-.991-.275-1.354-.093-.378.191-.613.563-.613.971.0.225.017.49.066.786.011.065.021.122.027.17-.041.038-.088.08-.143.129-.143.13-.319.292-.535.509-.498.504-.915 1.073-1.242 1.698-.952.375-1.634 1.011-1.862 1.754l-.23.749c-.163.53-.099 1.083.18 1.558.267.454.713.814 1.287 1.046.385 1.421 1.408 3.075 3.932 4.12l-.046.399c-.022.016-.058.038-.108.056l-5.05 1.823C10.89 31.552 6 27.82 6 25.5c0-3.173 9.112-9 24-9z"/></g><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/></svg>
              
                                  

                                              </span>

                                              </b-avatar> 
              

                  </b-col>
            
            
                      <b-col   cols="8" sm="8" md="8" xl="8" lg="8" >

                          
                              <p style="margin-bottom:0px; font-size:12px; text-align: center;line-height: 12px;margin-bottom:10px">Gana</p>

                           
                              <p style="text-align: center; margin-bottom:10px;font-weight: bold;font-size:20px" > 2 EQCoins</p>


                              <p style="margin-bottom:0px; font-size:12px; text-align: center;line-height: 12px;">Por registrar una contraseña a tu cuenta.</p>
                      

                      </b-col>
            
                </b-row>
            </b-card>

   

            </b-col>

            <b-col cols="12" sm="12" md="6" lg="4" xl="4" align="center">

                <b-card >

                  <b-form
                    autocomplete="off"
                    @submit.prevent="registerPassword"
                    >

                  <b-row>
                    <b-col cols="12" sm="12" md="12" lg="12" xl="12" align="center">
                              <p style="text-align: center;  font-size:15px; margin-bottom:10px; font-weight: bold;">Registro de contraseña</p>
                                <hr>

                      </b-col>

                      <b-col  cols="12" sm="12" md="12" lg="12" xl="12" style="margin-bottom:10px">
                        <b-alert
                              variant="secondary"
                              show
                            >
                              <div class="alert-body">
                                <p  class="textLabel" style="font-weight: bold;margin-bottom: 10px;">
                                Su contraseña debe cumplir con los siguientes requisitos:
                              </p>
                               
                                <p class="frmValidation" :class="{'frmValidation--passed' : has_minLongitud == true}">

                                  <feather-icon
                                    :icon="icon1"
                                    size="21"
                                    :class="has_minLongitud == true ? 'color_green' : 'color_red'"
                                  />


                                  Debe tener una longitud mínima de 9 caracteres.
                                  </p>
                                  <p class="frmValidation" :class="{'frmValidation--passed' :has_uppercase }">
                                  <feather-icon
                                    :icon="icon2"
                                    size="21"
                                    :class="has_uppercase == true ? 'color_green' : 'color_red'"
                                  /> Debe tener al menos una letra en mayúscula.</p>
                                  <p class="frmValidation" :class="{'frmValidation--passed' :has_lowercase }">
                                  <feather-icon
                                    :icon="icon3"
                                    size="21"
                                    :class="has_lowercase == true ? 'color_green' : 'color_red'"
                                  /> Debe tener al menos una letra en minúscula.</p>
                                  <p class="frmValidation" :class="{'frmValidation--passed' : has_number }">
                                  <feather-icon
                                    :icon="icon4"
                                    size="21"
                                    :class="has_number == true ? 'color_green' : 'color_red'"
                                  />
                                  Debe tener al menos un número.</p>
                                  <p class="frmValidation" :class="{'frmValidation--passed' : has_special }">

                                  <feather-icon
                                    :icon="icon5"
                                    size="21"
                                    :class="has_special == true ? 'color_green' : 'color_red'"
                                  />
                                  Debe tener al menos un caracter especial.</p>

                              </div>
                            </b-alert>
                      </b-col>

                      <b-col cols="12" sm="12" md="12" lg="12" xl="12" align="center">
                        <p  class="textLabel">
                                Ingrese una contraseña (*):
                              </p>

                              
                <b-form-group >
                  <b-input-group class="input-group-merge">
                    <b-form-input
                    required
                    autofocus
                      v-model="password"
                      :type="passwordFieldTypeNew"
                      name="new-password"
                      @input="password_check"
                      @paste.prevent
                      placeholder="Ingrese su contraseña"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        :icon="passwordToggleIconNew"
                        class="cursor-pointer"
                        @click="togglePasswordNew"
                      />
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>


     

                     

                            

                        
                             
                        
                        </b-col>

               <b-col
                cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                  xl="12"
            
                >

                <b-button
                          id="btn_password"
                          variant="primary"
                          block
                          :disabled="isDisabled2"
                          @click="registerPassword"

                 
                        >

                        Registrar contraseña
                        </b-button>

                </b-col>

                  </b-row>

   </b-form>
       
                </b-card>


                </b-col>

            <b-col cols="12" sm="12" md="12" lg="2" xl="2" align="center"></b-col>



          <b-col
            style="color:black !important;margin: auto; "
            sm="12"
            md="12"
            lg="12"
            xl="12"
            class="text-center align-items-center justify-content-xl-between"
   
          >
          <hr>


            <a
              target="_blank"
              title="Facebook de EQCoop"
              href="https://www.facebook.com/eqpay.oficial"
            >   <feather-icon
             icon="FacebookIcon"
             size="25"
             class="redes"
             /></a>
            <a
              target="_blank"
              title="Instagram de EQCoop"
              href="https://www.instagram.com/eqpay.oficial"
            > <feather-icon
             icon="InstagramIcon"
             size="25"
             class="redes"
             /></a>
            <a
              target="_blank"
              title="Email de EQCoop"
              href="mailto:hola@eqcoops.com?Subject=Tengo%20una%20pregunta"
            > <feather-icon
             icon="MailIcon"
             size="25"
             class="redes"
             /></a>
            <a
              target="_blank"
              title="Tiktok de EQCoop"
              href="https://www.tiktok.com/@eqpays?_t=8WRpV7M3v65&_r=1"
            > <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="#00838C"
              widht="10"
              height="22"
              viewBox="0 0 448 512"
            ><path d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z" /></svg></a>

            <p style="margin-top: 10px; margin-bottom:0; font-size: 12px;">  <a
              href="#"
              target="_blank"
            >Términos y condiciones</a> - <b-link
              :to="{ name: 'privacidad'}"
              target="_blank"
            >Política de privacidad y condiciones de servicios</b-link> -  <a
              href="#"
              target="_blank"
            >Reclamos</a></p>

            <p style="margin-top: 0px; font-size: 12px;    margin-bottom: 10px;"> Copyright &copy; {{ year }} <a
              href="https://web.eqcoops.com"
              target="_blank"
            >- EQCoop</a></p>

          </b-col>


        </b-row>

        
        
      </div>
        
        </template>
        
        <script>
        import {
          BButton,BRow, BCol, BCard,BAvatar, BLink, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend,BAlert, BForm
        } from 'bootstrap-vue'

      import Vue from 'vue'
        export default {
          components: {
            BButton,
            BForm,
            BAlert,
            BAvatar,
            BRow,
            BCol,
            BCard,
            BLink,
            BFormInput, BFormGroup, BInputGroup, BInputGroupAppend
          },
          data() {
            const datos_json = JSON.parse(this.$userGlobal);

            let contacto="";

            contacto=  datos_json.phone;

              if(contacto === ""){
                contacto=  datos_json.email;

              }
         
            return {
                
                year: new Date().getFullYear(),
                displayName:datos_json.displayName,
                phone:datos_json.phone,
                hasPassword: datos_json.hasPassword,
                 password:  '',
                  has_number:    false,
                  has_lowercase: false,
                  has_uppercase: false,
                  has_special:   false,
                  has_minLongitud:   false,
                  passwordFieldTypeNew: 'password',
                  icon1: "XCircleIcon",
                  icon2: "XCircleIcon",
                  icon3: "XCircleIcon",
                  icon4: "XCircleIcon",
                  icon5: "XCircleIcon",
                  photoUser: datos_json.photoUser,
                  isProfileVerificated: datos_json.isProfileVerificated,
                  contacto:contacto,
                  userId:datos_json.userId,
                   tokenAuth:this.$tokenGlobal,
                   isDisabled2:true,
                
            }
          },
          computed: {
            passwordToggleIconNew() {
              return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon'
            },
          },
          watch: {
    
            

    
        
          },
            mounted() {
    
              if(this.phone){

                if(this.hasPassword === "true" || this.hasPassword === true){

                    this.$router.push('/dashboard')

                    }

              }else{
                this.$router.push('/dashboard')
              }
          
    
             
            document.title = 'EQCoop - Registro de contraseña';

            window.onscroll = function() {
              var scroll = window.pageYOffset;
            
              if (scroll >= 30) {

                
                document.getElementById("logoEQ").classList.remove('logoSVG2')
                document.getElementById("logoEQ").classList.add('eq_color')
      
                document.getElementById("menu_fixed").classList.add('background_filter')
         
                
              } else {

                document.getElementById("logoEQ").classList.remove('eq_color')
                document.getElementById("logoEQ").classList.add('logoSVG2')

                document.getElementById("menu_fixed").classList.remove('background_filter')
             
             
                  
              }
         
            }

                    
           
          },
          methods: {

                 
            registerPassword() {

              let mensaje="";
    
     
               

            if(!this.has_minLongitud){
              mensaje="Su contraseña debe tener una longitud mínima de 9 caracteres.";
            }

            if(!this.has_number){
              mensaje="Su contraseña debe tener al menos un número.";
            }

        
            if(!this.has_lowercase){
              mensaje="Su contraseña debe tener al menos una letra en minúscula.";
            }
          
            if(!this.has_uppercase){
              mensaje="Su contraseña debe tener al menos una letra en mayúscula.";
            }
          
            if(!this.has_special){
              mensaje="Su contraseña debe  tener al menos un caracter especial.";
            }

            if(this.has_minLongitud &&  this.has_number &&  this.has_lowercase &&  this.has_uppercase &&  this.has_special ){ 


              

              this.$swal({
                              title: "¿Estas seguro?",
                              text: `La contraseña que ingresaste es: ${this.password}`,
                              icon: 'warning',
                              showCancelButton: true,
                              confirmButtonText: "Confirmar contraseña",
                              cancelButtonText: 'Cancelar',
                              customClass: {
                              confirmButton: 'btn btn-primary',
                              cancelButton: 'btn btn-outline-secondary ml-1',
                              },
                              buttonsStyling: false,
                              showLoaderOnConfirm: true,
                              preConfirm: () => {
                           

                                          
                                                  
                                const data_json = { userId: this.userId, password: this.password }
                                  const data_string = JSON.stringify(data_json)



                                  const dataEncripted = this.$encryptBackoffice.encrypt(data_string);

                              return this.$https.post('/profile/registerPassword/', { tokenAuth: this.tokenAuth, data: dataEncripted }).then(response => response.data).catch(error => {
                                this.$swal.showValidationMessage(
                                  error,
                                )
                              })
                              },
                              allowOutsideClick: () => !this.$swal.isLoading(),
                              }).then(result => {

                              this.$swal.close()

                              if(result.isConfirmed){
                              
                                

                              if (result.value.code == 200) {

                               
                
                                    this.$toast.success(result.value.message, {
                                      position: 'top-right',
                                      timeout: 3010,
                                      closeOnClick: true,
                                      pauseOnFocusLoss: false,
                                      pauseOnHover: true,
                                      draggable: true,
                                      draggablePercent: 0.4,
                                      showCloseButtonOnHover: false,
                                      hideProgressBar: true,
                                      closeButton: 'button',
                                      icon: true,
                                      rtl: false,
                                    })

                                    const datos_json = JSON.parse(this.$userGlobal);

                                      datos_json.hasPassword = true


                                      Vue.prototype.$userGlobal= JSON.stringify(datos_json);

                                      localStorage.setItem('userData', JSON.stringify(datos_json));


                                  
                                    if(Number(result.value.eqpoints) > 0){

                                      
                                        this.eqcoins(result.value.eqpoints, "registrar una contraseña a tu cuenta de EQCoop", "");

                                    }
                                
                                        this.$router.push('/dashboard')




                                      } else {

                                        
                                    
                  
                                      this.$toast.error(result.value.message, {
                                      position: 'top-right',
                                      timeout: 3010,
                                      closeOnClick: true,
                                      pauseOnFocusLoss: false,
                                      pauseOnHover: true,
                                      draggable: true,
                                      draggablePercent: 0.4,
                                      showCloseButtonOnHover: false,
                                      hideProgressBar: true,
                                      closeButton: 'button',
                                      icon: true,
                                      rtl: false,
                                      })
                  
                                      if (result.value.code == 401) {
                                         
                                            
                                            localStorage.removeItem('userData')
                                              
                                              

                                            
                                            

                                          

                                            
                                            

                                            // Redirect to login page
                                            this.$router.push({ name: 'auth-login' })
                  
                                      } 

                                      }

                              }





                              })



             
           
            }else{
              this.$toast.error(mensaje, {
                position: 'top-right',
                timeout: 3010,
                closeOnClick: true,
                pauseOnFocusLoss: false,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.4,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: 'button',
                icon: true,
                rtl: false,
              })
            }


            },
            
        logout() {
            this.exit(this.userId,this.tokenAuth, true);
  


            },

            openModalProfile(){
        this.$refs.modalProfile.show();
      },
            password_check(value){

              if(Number(value.length) >= Number("9")){
                this.has_minLongitud=true;
                this.icon1="CheckCircleIcon"
              }else{
                this.has_minLongitud=false;
                this.icon1="XCircleIcon"
              }
            this.has_number    = /\d/.test(this.password);
            if(this.has_number){
              this.icon4="CheckCircleIcon"
            }else{
              this.icon4="XCircleIcon"
            }
            this.has_lowercase = /[a-z]/.test(this.password);
            if(this.has_lowercase){
              this.icon3="CheckCircleIcon"
            }else{
              this.icon3="XCircleIcon"
            }
            this.has_uppercase = /[A-Z]/.test(this.password);
            if(this.has_uppercase){
              this.icon2="CheckCircleIcon"
            }else{
              this.icon2="XCircleIcon"
            }
            this.has_special   = /[!@#\$%\^\&*\)\(+=._-]/.test(this.password);
            if(this.has_special){
              this.icon5="CheckCircleIcon"
            }else{
              this.icon5="XCircleIcon"
            }

            if(this.has_minLongitud &&  this.has_number &&  this.has_lowercase &&  this.has_uppercase &&  this.has_special ){ 
              this.isDisabled2= false;

            }else{
              this.isDisabled2= true;
            }
        },
        togglePasswordNew() {
      this.passwordFieldTypeNew = this.passwordFieldTypeNew === 'password' ? 'text' : 'password'
    },

 
           
        
          },
        }
        </script>
        
        <style lang="scss">

    
            
        </style>
        